import React, { useState } from 'react';
import { Maximize2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import MapExpandedModal from './MapExpandedModal';

/**
 * Compact clickable map card. Clicking opens the enlarged modal
 * where the 5 interactive hover zones live.
 */
const MapCard = ({ index = 0, onCityOpen }) => {
  const { t } = useLanguage();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <motion.button
        type="button"
        onClick={() => setIsExpanded(true)}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: index * 0.1 }}
        className="group relative h-96 w-full overflow-hidden rounded-2xl bg-[#F5F2ED] shadow-sm transition-all duration-500 hover:shadow-2xl text-left p-0 border-0 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4C2A1]"
        data-testid="destination-map-card"
        aria-label="Open interactive map of Colombia"
      >
        <img
          src="/inaluna-colombia-map-v3.jpg"
          alt="Inaluna DMC - Colombia watercolor map with San Andrés y Providencia"
          className="absolute inset-0 w-full h-full object-contain select-none pointer-events-none transition-transform duration-700 group-hover:scale-105"
          draggable={false}
          data-testid="colombia-map-image"
        />

        {/* Expand icon badge */}
        <span className="absolute top-4 right-4 z-20 flex items-center gap-2 bg-[#1A2B3C]/80 backdrop-blur-sm text-[#D4C2A1] text-[10px] uppercase tracking-[0.3em] px-3 py-1.5 rounded-full transition-all duration-300 group-hover:bg-[#D4C2A1] group-hover:text-[#1A2B3C]">
          <Maximize2 size={12} />
          <span className="hidden sm:inline">{t('explore_map') || 'Explore'}</span>
        </span>

        {/* Bottom title — matches destination cards (uppercase, tracking, serif) */}
        <div className="absolute inset-x-0 bottom-0 z-20 px-6 pb-6 pt-10 pointer-events-none bg-gradient-to-t from-[#1A2B3C] via-[#1A2B3C]/85 to-transparent">
          <div className="flex flex-col items-center">
            <h3
              className="text-center text-white uppercase tracking-[0.25em] text-xl md:text-2xl font-bold leading-tight"
              data-testid="map-card-title"
            >
              {t('map_card_title')}
            </h3>
            <div className="mt-3 h-px w-12 bg-[#D4C2A1]" />
          </div>
        </div>
      </motion.button>

      <MapExpandedModal
        isOpen={isExpanded}
        onClose={() => setIsExpanded(false)}
        onCityOpen={onCityOpen}
      />
    </>
  );
};

export default MapCard;
